<template>
  <headers />
  <div class="el-div">
    <el-form
      :model="ruleForm"
      status-icon
      ref="ruleForm"
      label-width="30%"
      class="demo-ruleForm"
    >
      <el-form-item label="* 原密码" prop="oldPassword">
        <el-input
          v-model="ruleForm.oldPassword"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="* 新密码" prop="NewPassword">
        <el-input
          v-model="ruleForm.NewPassword"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="* 确认新密码" prop="NewPasswordTwo">
        <el-input v-model="ruleForm.NewPasswordTwo"></el-input>
      </el-form-item>
      <el-form-item label-width="0">
        <el-button class="el-button-cuc" type="primary" @click="submitForm(ruleForm)"
          >提交</el-button
        >
        <el-button class="el-button-cuc" @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<style scoped>
.el-div {
  width: 1200px;
  margin: 30px auto;
}
.el-input {
  display: block;
  width: 380px;
}
.el-button-cuc,.el-button-cuc:hover,.el-button-cuc:focus{
	background-image:none;
	background-color:#059490;
	width:120px;
	line-height: 1;
	padding:10px 0;
	cursor: pointer;
	border:1px solid #04726f;
	font-family:"Microsoft YaHei";
	font-size:16px;
	height:40px;
	line-height:20px;
	border-radius:6px;
	margin: 8px 0 0 10px;
	color:#fff;
	text-align:center;
	position:relative;
	box-sizing: border-box;
}
</style>
<script>
import headers from "../views/Home.vue";
import { UpdatePassword } from "../http/api.ts";
import { ElMessage } from "element-plus";
import Route from "../router/index";
export default {
   components: {
    headers,
  },
  data() {        
    return {
      ruleForm: {
        oldPassword: "",
        NewPassword: "",
        NewPasswordTwo: ""
      }
          };
  },
  methods: {
    submitForm(formName) {      
          if(this.ruleForm.oldPassword.length==0||this.ruleForm.NewPassword.length==0||this.ruleForm.NewPasswordTwo.length==0){
            ElMessage.error({message:'必填项不能为空！',offset: 300});
            return false;
          }
          if(this.ruleForm.NewPassword!=this.ruleForm.NewPasswordTwo){
            ElMessage.error({message:'新密码与确认新密码输入不一致！',offset: 300});
            return false;
          }
          const loading = this.$loading({
            lock: true,
            text: "提交中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          UpdatePassword(formName).then((res) => {
            if (res.code == 200) {
              ElMessage.success({message:res.msg,offset: 300});
              setTimeout(function () {
                  Route.push("read?tmsite="+Math.random());
              }, 1000);
            }else{
             ElMessage.error({message:res.msg,offset: 300});
            }
            loading.close();
          }); 
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>